import type { ReactNode } from 'react';

import type { VirtualizeProps } from '../types';

/**
 * Enables row virtualization for large datasets.
 * Only renders visible rows plus overscan buffer for performance.
 *
 * @param overscan - Number of rows to render outside visible area (default: 5)
 * @param estimateSize - Override row height in pixels (default: derived from density)
 *
 * @example
 * ```tsx
 * // Basic - row height derived from density
 * <DataTable.Settings>
 *   <DataTable.Virtualize />
 * </DataTable.Settings>
 *
 * // Custom overscan and row height
 * <DataTable.Settings>
 *   <DataTable.Virtualize overscan={10} estimateSize={36} />
 * </DataTable.Settings>
 * ```
 */
export const Virtualize = (_props: VirtualizeProps): ReactNode => {
  return null;
};

Virtualize.displayName = 'DataTable.Virtualize';
